import "./ImageGallery.scss";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {useNavigate} from 'react-router-dom';

const ImageGallery = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const image1Click = useCallback(() => navigate('/whatisarbitration', {replace: false}), [navigate]);
  const image2Click = useCallback(() => navigate('/whatismediation', {replace: false}), [navigate]);
  const image5Click = useCallback(() => navigate('/radioprogram', {replace: false}), [navigate]);
  // const image6Click = useCallback(() => navigate('/information', {replace: false}), [navigate]);

  useEffect(() => {
    // Shorter animation duration for better mobile experience
    const duration = window.innerWidth <= 768 ? 1500 : 3000;
    Aos.init({ duration: duration, startEvent: "scroll" });
  }, []);
  
  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        <div 
          className="gallery-item" 
          data-aos="fade-top"
          onClick={image2Click}
        >
          <img src={t("gallery_image2")} alt="Mediation" />
        
        </div>
        
        <div 
          className="gallery-item" 
          data-aos="fade-right"
          onClick={image5Click}
        >
          <img src={t("gallery_image5")} alt="Radio Program" />
         
        </div>
        
        <div 
          className="gallery-item" 
          data-aos="fade-right"
          onClick={image1Click}
        >
          <img src={t("gallery_image1")} alt="Arbitration" />
         
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;